// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"page_mainDiv__uFVvm","labelsDiv":"page_labelsDiv__Sf_Ge","mainBox":"page_mainBox__RS6F_","insideBox":"page_insideBox__FIOWf"};